module.exports = __webpack_public_path__ + "static/media/drawer_profile_active.1e327d27.svg";